import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { translateFormFieldLabel } from '../../../../../../helpers/collaborativeIndexations'
import classNames from 'classnames'

class Age extends Component
{
    static propTypes = {
        t: PropTypes.func.isRequired,
        updateFieldValue: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
        isInvalidField: PropTypes.func.isRequired,
        resetInvalidField: PropTypes.func.isRequired,
    }

    constructor(props)
    {
        super(props)

        this.handleOnChange = this.handleOnChange.bind(this)
    }

    handleOnChange(event)
    {
        const { resetInvalidField, updateFieldValue } = this.props

        resetInvalidField("age")
        updateFieldValue("age", event.target.value)
    }

    render()
    {
        const { t, fields, isInvalidField } = this.props

        return (
            <div className={"form-group age"}>
                <label>{ translateFormFieldLabel(t, "age") }</label>
                <input
                    defaultValue={fields.age}
                    className={classNames("age-input", {"error": isInvalidField("age")})}
                    onChange={this.handleOnChange}
                    type={"number"} min={"0"} max={"199"} step={"1"}
                />
                {t("visualizer:toolbar.left.collaborativeIndexationCreation.form.common.steps.identity.ageYear", { count: parseInt(fields.age)})}
            </div>
        )
    }
}

export default withTranslation()(Age)
